import React from 'react';
import StockBalanceModule from '../stockbalance/components/StockBalanceModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';


export default function InventoryStockBalanceModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.stockbalance', action: 'read' },
        { resource: 'inventory.item', action: 'read' },
      ]}
    >
      <StockBalanceModule />
    </InventoryPermissionGuard>
  );
}